<template>
  <div class="modal-content" style="max-width: 95vw;">
    <div class="modal-header">
      <h5 class="modal-title">
        {{ isEdit ? 'Izmeni' : 'Dodaj novu' }} Registraciju
      </h5>
    </div>
    <div class="modal-body">
      <div v-if="loading" class="text-center">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div v-else>
        <!-- Basic Info -->
        <div class="row mb-3">
          <div class="col-md-3">
            <label class="form-label">Važi od <span class="text-danger">*</span></label>
            <input type="date" class="form-control" v-model="formData.valid_from" :disabled="isEdit" required />
          </div>
          <div class="col-md-3">
            <label class="form-label">Aktivno</label>
            <div class="form-check mt-2">
              <input type="checkbox" class="form-check-input" v-model="formData.active" />
            </div>
          </div>
        </div>

        <!-- Tabs for Vehicle Types -->
        <ul class="nav nav-tabs mb-3" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active" id="obicno-tab" data-bs-toggle="tab" data-bs-target="#obicno" type="button"
              role="tab" aria-controls="obicno" aria-selected="true">
              Obicno vozilo
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="mhev-tab" data-bs-toggle="tab" data-bs-target="#mhev" type="button" role="tab"
              aria-controls="mhev" aria-selected="false">
              m-HEV
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="teretno-tab" data-bs-toggle="tab" data-bs-target="#teretno" type="button"
              role="tab" aria-controls="teretno" aria-selected="false">
              Teretno
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" id="elektricno-tab" data-bs-toggle="tab" data-bs-target="#elektricno" type="button"
              role="tab" aria-controls="elektricno" aria-selected="false">
              Električno
            </button>
          </li>
        </ul>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Obicno Tab -->
          <div class="tab-pane fade show active" id="obicno" role="tabpanel" aria-labelledby="obicno-tab">
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Zapremina ccm</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in ccRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Obicno[range].godina_1" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Obicno[range].godina_2" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Obicno[range].godina_3" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Obicno[range].godina_4" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Obicno[range].godina_5" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- m-HEV Tab -->
          <div class="tab-pane fade" id="mhev" role="tabpanel" aria-labelledby="mhev-tab">
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Zapremina ccm</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in ccRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData['m-HEV'][range].godina_1" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData['m-HEV'][range].godina_2" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData['m-HEV'][range].godina_3" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData['m-HEV'][range].godina_4" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData['m-HEV'][range].godina_5" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Teretno Tab -->
          <div class="tab-pane fade" id="teretno" role="tabpanel" aria-labelledby="teretno-tab">
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Zapremina ccm</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="range in ccRanges" :key="range">
                    <td><strong>{{ range }}</strong></td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Teretno[range].godina_1" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Teretno[range].godina_2" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Teretno[range].godina_3" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Teretno[range].godina_4" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Teretno[range].godina_5" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Elektricno Tab -->
          <div class="tab-pane fade" id="elektricno" role="tabpanel" aria-labelledby="elektricno-tab">
            <div class="table-responsive">
              <table class="table table-bordered table-sm" style="width: 100%; table-layout: fixed;">
                <thead class="table-light">
                  <tr>
                    <th style="width: 20%;">Tip</th>
                    <th style="width: 16%;">1. godina</th>
                    <th style="width: 16%;">2. godina</th>
                    <th style="width: 16%;">3. godina</th>
                    <th style="width: 16%;">4. godina</th>
                    <th style="width: 16%;">5. godina</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong>Električno</strong></td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Elektricno['Elektricno'].godina_1" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Elektricno['Elektricno'].godina_2" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Elektricno['Elektricno'].godina_3" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Elektricno['Elektricno'].godina_4" />
                    </td>
                    <td>
                      <input type="number" step="0.01" class="form-control form-control-sm"
                        v-model.number="formData.Elektricno['Elektricno'].godina_5" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" @click="cancel">
        Odustani
      </button>
      <button type="button" class="btn btn-primary" @click="saveData">
        Sačuvaj
      </button>
    </div>
  </div>
</template>

<script>
import RegistrationDataService from "../../services/registration.service";

export default {
  name: "registration-form",
  props: ["data"],
  data() {
    const emptyRange = () => ({ godina_1: null, godina_2: null, godina_3: null, godina_4: null, godina_5: null });

    return {
      loading: false,
      ccRanges: [
        "do 1150",
        "preko 1150-1300",
        "preko 1300-1600",
        "preko 1600-2000",
        "preko 2000-2500",
        "preko 2500-3000",
        "preko 3000",
      ],
      vehicleTypes: ["Obicno", "m-HEV", "Teretno", "Elektricno"],
      formData: {
        valid_from: "",
        active: true,
        Obicno: {
          "do 1150": emptyRange(),
          "preko 1150-1300": emptyRange(),
          "preko 1300-1600": emptyRange(),
          "preko 1600-2000": emptyRange(),
          "preko 2000-2500": emptyRange(),
          "preko 2500-3000": emptyRange(),
          "preko 3000": emptyRange(),
        },
        "m-HEV": {
          "do 1150": emptyRange(),
          "preko 1150-1300": emptyRange(),
          "preko 1300-1600": emptyRange(),
          "preko 1600-2000": emptyRange(),
          "preko 2000-2500": emptyRange(),
          "preko 2500-3000": emptyRange(),
          "preko 3000": emptyRange(),
        },
        Teretno: {
          "do 1150": emptyRange(),
          "preko 1150-1300": emptyRange(),
          "preko 1300-1600": emptyRange(),
          "preko 1600-2000": emptyRange(),
          "preko 2000-2500": emptyRange(),
          "preko 2500-3000": emptyRange(),
          "preko 3000": emptyRange(),
        },
        Elektricno: {
          "Elektricno": emptyRange(),
        },
      },
    };
  },
  computed: {
    isEdit() {
      return this.data && this.data.valid_from;
    },
  },
  mounted() {
    if (this.isEdit) {
      this.loadData();
    }
  },
  methods: {
    async loadData() {
      this.loading = true;
      this.formData.valid_from = this.data.valid_from;

      // Load data for all three vehicle types
      try {
        const promises = this.vehicleTypes.map(type =>
          RegistrationDataService.getByValidFromAndType(this.data.valid_from, type)
            .then(response => ({ type, records: response.data }))
            .catch(() => ({ type, records: [] }))
        );

        const results = await Promise.all(promises);

        results.forEach(({ type, records }) => {
          records.forEach((record) => {
            if (this.formData[type] && this.formData[type][record.zapremina_ccm]) {
              this.formData[type][record.zapremina_ccm] = {
                godina_1: record.godina_1,
                godina_2: record.godina_2,
                godina_3: record.godina_3,
                godina_4: record.godina_4,
                godina_5: record.godina_5,
              };
            }
            this.formData.active = record.active;
          });
        });

        this.loading = false;
      } catch (e) {
        console.log(e);
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: "Error loading registration data",
        });
        this.loading = false;
      }
    },
    async saveData() {
      if (!this.formData.valid_from) {
        this.$store.commit("app/showAlert", {
          type: "warning",
          message: "Molimo popunite obavezno polje (Važi od)",
        });
        return;
      }

      if (this.isEdit) {
        await this.update();
      } else {
        await this.create();
      }
    },
    cancel() {
      this.$store.commit("app/hideModal");
    },
    getRangesForType(type) {
      if (type === 'Elektricno') {
        return ['Elektricno'];
      }
      return this.ccRanges;
    },
    async update() {
      try {
        // Update all three vehicle types
        const promises = this.vehicleTypes.map(type => {
          const typeData = {};
          const ranges = this.getRangesForType(type);
          ranges.forEach(range => {
            typeData[range] = this.formData[type][range];
          });

          return RegistrationDataService.update(
            this.formData.valid_from,
            type,
            { ...typeData, active: this.formData.active }
          );
        });

        await Promise.all(promises);

        this.$store.commit("app/showAlert", {
          type: "success",
          message: "Registracija je promenjena!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
    async create() {
      try {
        // Create all three vehicle types
        const promises = this.vehicleTypes.map(type => {
          const typeData = {};
          const ranges = this.getRangesForType(type);
          ranges.forEach(range => {
            typeData[range] = this.formData[type][range];
          });

          return RegistrationDataService.create({
            valid_from: this.formData.valid_from,
            type: type,
            ...typeData,
            active: this.formData.active,
          });
        });

        await Promise.all(promises);

        this.$store.commit("app/showAlert", {
          type: "success",
          message: "Registracija je kreirana!",
        });
        this.$store.commit("app/hideModal");
      } catch (e) {
        this.$store.commit("app/showAlert", {
          type: "danger",
          message: e.response?.data?.message || e.message,
        });
      }
    },
  },
};
</script>

<style scoped>
.table {
  font-size: 0.875rem;
  margin-bottom: 0;
}

.table th {
  background-color: #f8f9fa;
  font-weight: 600;
  text-align: center;
  vertical-align: middle;
  padding: 0.5rem 0.25rem;
  white-space: nowrap;
}

.table td {
  vertical-align: middle;
  padding: 0.4rem 0.25rem;
}

.form-control-sm {
  font-size: 0.875rem;
  padding: 0.3rem 0.4rem;
  width: 100%;
}

.modal-body {
  padding: 1rem 1.5rem;
}

.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}

.nav-tabs {
  margin-bottom: 1rem;
}

.tab-content {
  padding: 0;
}

.row.mb-3 {
  margin-bottom: 1rem !important;
}
</style>
